export default {
    props: {},
    data: function () {
        return {
            entityService: null,
            indexSelected: null,
            form: { alert: { alerts: [], type: "error" } },
            loading: false,
            alert: { alerts: [], type: "error" },
            itemSelected: null,
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        async editItem(itemId) {
            
				console.log("saveJob", itemId);
            let res = await this.entityService.getById(itemId);
            if (res.success) this.itemSelected = res.data;

            if (this.itemSelected) {
                this.itemSelectedRef = this.itemSelected;
                let obj = {};
                Object.assign(obj, this.itemSelected);
                this.itemSelected = obj;
                return true;
            }

            return res.success;

        },
        async saveItem(item) {
            this.loading = true;
            var res = await this.entityService.insertOrUpdate(item);

            if (res.success) {
                this.itemSelected = null;
                this.itemSelectedRef = null;
                return true;
            }

            else this.errorNotification(res.data);

            this.loading = false;
            return res.success
        },
        async deleteItem(item) {
            if (!(await this.$confirm())) {
                return false;
            }
            this.loading = true;

            var res = await this.entityService.delete(item.id);
            if (res.success) {
                this.itemSelected = null;
                this.itemSelectedRef = null;
                return true;
            }
            else this.errorNotification(res.data);

            this.loading = false;
            return res.succes;

        },
        errorNotification(list) {

            this.alert.alerts = list;
            this.alert.type = "error";
        },

    }
}